import React from "react";
import styled, { css } from "styled-components";

const FileContainer = styled.div`
  position: relative;
  display: table;
  vertical-align: top;
  width: 460px;
  margin-right: 20px;
  margin-left: 212px;
  
  ${props => props.theme.direction === "rtl" && css`
    margin-right: 212px;
    margin-left: 20px;
  `};
  
  ${props => !props.desktop && css`
    position: fixed;
    top: 0px;
    left: 0px;
    display: block;
    width: 100%;
    height: 100%;
    margin: 0px;
    background-color: rgba(0,0,0,0.5);
    z-index: 100100;
  `}
`;

const FileWrapperMobile = styled.div`
  ${props => !props.desktop && css`
    position: relative;
    height: 100%;
    width: 90%;
    margin: 0 auto;
    padding-top: 100px;
    @media (max-width: 800px) {
      padding-top: 50px;
    }
  `}
`;

const File = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  max-height: 85%;
  max-width: 100%;
  border: none;
  box-shadow: 0 0 18px 5px rgba(0, 0, 0, 0.15);
  
  ${props => !props.desktop && css`
    top: 153px;
    left: 50%;
    transform: translate(-50%, 0);
    max-height: 75%;
    @media (max-width: 800px) {
      top: 103px;
    }
    @media (min-width: 415px) and (max-width: 480px) {
      max-height: 195px;
      max-width: 260px;
    }
    @media (min-width: 481px) and (max-width: 640px) {
      max-height: 215px;
    }
  `}
`;

const CloseImage = styled.div`
  position: absolute;
  top: 35px;
  right: 0px;
  width: 18px;
  height: 18px;
  background-size: cover;
  cursor: pointer;
  z-index: 100101;
  :before {
    content: "";
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    transform-origin: 100%;
    width: 0px;
    height: 24px;
    border-left: 2px solid #fff;
    transition: all 0.3s ease;
  }
  :after {
    content: "";
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%) rotate(-45deg);
    transform-origin: 0%;
    width: 0px;
    height: 24px;
    border-left: 2px solid #fff;
    transition: all 0.3s ease;
  }
  :hover {
    :before {
      border-left-color: #60a31c;
    }
    :after {
      border-left-color: #60a31c;
    }
  }
  
  ${props => !props.desktop && css`
    top: 115px;
    @media (max-width: 800px) {
      top: 65px;
    }
  `}
`;

const Section = styled.section`
  margin-top: 22px;
  border-bottom: 0px;
  :first-of-type {
    margin-top: 35px;
  }
  :nth-of-type(n+2) {
    padding-bottom: 20px;
  }
  @media (max-width: 959px) {
    margin-top: 0px;
    border-bottom-color: #f6f6f6;
    padding-bottom: 10px;
  }
  
  ${props => !props.desktop && css`
    margin: 0 auto;
    margin-top: 15px;
    :first-of-type {
      margin-top: 15px;
    }
    :nth-of-type(2) {
      margin-top: 15px;
      @media (max-width: 959px) {
        margin-top: 20px;
      }
    }
    @media (max-width: 414px) {
      max-width: 100%;
    }
    @media (max-width: 480px) {
      max-width: 290px;
    }
    @media (max-width: 640px) {
      max-width: 388px;
    }
    @media (max-width: 736px) {
      max-width: 446px;
    }
  `}
  
  ${props => props.file && css`
    :nth-of-type(2n) {
      padding-bottom: 0px;
    }
  `}
`;

const OfflineFilePreview = ({ Row, desktop, onClose, file }) =>
  <Section
    desktop={desktop}
    file={file}
  >
    <Row nowrap={true}>
      <FileContainer
        desktop={desktop}
        style={desktop ? { height: 376 } : null} // десктоп: такой же высоты, как предыдущая section (которая скрывается)
      >
        <FileWrapperMobile desktop={desktop}>
          {!desktop &&
            <CloseImage
              desktop={desktop}
              onClick={onClose}
            />}
          <File
            desktop={desktop}
            src={file || "http://placehold.it/262x361"}
            alt="preview"
          />
        </FileWrapperMobile>
      </FileContainer>
    </Row>
  </Section>;

export default OfflineFilePreview;



// WEBPACK FOOTER //
// ./src/components/OfflinePopup/OfflineFilePreview.js